import loginAPI from "./loginAPI";
import 'tui-grid/dist/tui-grid.css';

export default {
  
  async login(userNo, userPasswd) {
    try {
      const loginResponse = await loginAPI.login(userNo, userPasswd);

      return loginResponse;
    } catch (err) {
      console.error(err);
    }
  }
};
